import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import DataTable from "../../component/DataTable";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const emailListEndpoint = ApiEndpoints.emailManagement.List;
const emailDeleteEndpoint = ApiEndpoints.emailManagement.Delete;
const emailEditPath = "edit-email-management";

const tableHeader = ["Date", "Form Type", "To", "CC", "BCC"];
const tbody = ["createdAt", "form_type", "toText", "ccText", "bccText"];

const formatEmailList = (emails) => Array.isArray(emails) && emails.length ? emails.join(", ") : "N/A";

export default function EmailManagement() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", emailListEndpoint);
      setData(response.dynamic_emails || []);
    } catch (error) {
      console.log(error);
      toast.error("Unable to fetch email management records.");
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const tableData = useMemo(() => (
    data.map((item) => ({
      ...item,
      toText: formatEmailList(item.to),
      ccText: formatEmailList(item.cc),
      bccText: formatEmailList(item.bcc),
    }))
  ), [data]);

  const handleDelete = async (dynamicemail_id) => {
    if (!window.confirm("Delete this email management record?")) return;

    try {
      const response = await ApiRequest("POST", emailDeleteEndpoint, { dynamicemail_id });
      if (response.error) {
        toast.error(response.message);
        return;
      }
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
      toast.error("Unable to delete email management record.");
    }
  };

  const pagename = {
    name: "Email Management",
    user: "Admin",
    innerpage: "Email Management",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-email-management"> Add +</Link>
        <DataTable
          data={tableData}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={emailEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
